export default {
  loading: false
}